import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Grid, Typography, Stepper, Step, StepLabel } from '@mui/material';

import { API } from 'aws-amplify';

import Step1 from './step1';
import Step2 from './step2';
import ErrorView from '../error';
import { open, close } from '../../features/loading/loadingSlice';
import { updateDate } from '../../features/entry/entrySlice';

const Content = (props) => {
  useEffect(() => { getDate(); }, []);

  const steps = ['基本情報', 'ビンゴカード設定'];
  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return <Step1 />;
      case 1:
        return <Step2 />;
      default:
        return 'Unknown stepIndex';
    }
  };

  const getDate = () => {
    let data = { body: { operation: 'getDate' } };
    props.open();
    API.post('uabingoapi', '/entry', data)
      .then(response => {
        props.close();
        props.updateDate(response);
      })
      .catch(error => {
        props.close();
        ErrorView(error.response.data.message);
      });

  }

  return (
    <>
      <Grid container>
        <Grid item xs={12} margin={3}>
          <Typography variant='h6' align='center'>イオン銀行従業員組合</Typography>
          <Typography variant='h5' align='center'>10周年記念全国ご当地オンラインビンゴ大会</Typography>
        </Grid>
        {
          props.closeDate === '' || props.openDate === '' ?
            <Grid item xs={12}></Grid> :
            (
              new Date() > new Date(props.closeDate) ?
                <Grid item xs={12}>
                  <Typography variant='h5' align='center' bgcolor='#b2dfdb'>エントリー受付は終了しました</Typography>
                  <Typography variant='h6' align='center' bgcolor='#b2dfdb'>たくさんのお申し込みありがとうございました</Typography>
                </Grid> :
                (
                  new Date() < new Date(props.openDate) ?
                    <Grid item xs={12}>
                      <Typography variant='h5' align='center' bgcolor='#b2dfdb'>只今サイト準備中です</Typography>
                      <Typography variant='h6' align='center' bgcolor='#b2dfdb'>ご理解とご協力をお願い致します</Typography>
                    </Grid> :
                    <Grid item xs={12}>
                      <Stepper activeStep={props.activeStep} alternativeLabel sx={{ margin: 2 }}>
                        {steps.map((label) => (
                          <Step key={label}><StepLabel>{label}</StepLabel></Step>
                        ))}
                      </Stepper>
                      {getStepContent(props.activeStep)}
                    </Grid>
                )
            )
        }
      </Grid>
    </>
  );
};

/** react-redux */
const mapStateToProps = (state) => {
  return {
    activeStep: state.entry.activeStep,
    closeDate: state.entry.closeDate,
    openDate: state.entry.openDate,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    open: () => dispatch(open()),
    close: () => dispatch(close()),
    updateDate: (...args) => dispatch(updateDate(...args)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Content);
